// extracted by mini-css-extract-plugin
module.exports = {"profile_preview":"FriendRequestPage_profile_preview__2in_Y","container":"FriendRequestPage_container__1H6J_","nofriends":"FriendRequestPage_nofriends__kVtQS"};